// export const SERVER_URL = "http://localhost:3002";
export const SERVER_URL = "https://theventia.herokuapp.com";
